'use strict';

import Session from './session';
export {default as Session} from './session';
const session = new Session();

export {default as JwtAuthSettings} from './jwt_auth_settings';
export {default as createQuestionnaireUrl} from './create_questionnaire_url';

import ListResponses from './api_endpoints/list_responses';
export {default as ListResponses} from './api_endpoints/list_responses';
export const listResponses = new ListResponses(session);

import CreateAuthUser from './api_endpoints/create_auth_user';
export {default as CreateAuthUser} from './api_endpoints/create_auth_user';
export const createAuthUser = new CreateAuthUser(session);

import CreatePerson from './api_endpoints/create_person';
export {default as CreatePerson} from './api_endpoints/create_person';
export const createPerson = new CreatePerson(session);

import ListPerson from './api_endpoints/list_person';
export {default as ListPerson} from './api_endpoints/list_person';
export const listPerson = new ListPerson(session);

import UpdateMyPerson from './api_endpoints/update_my_person';
export {default as UpdateMyPerson} from './api_endpoints/update_my_person';
export const updateMyPerson = new UpdateMyPerson(session);

import ListDistribution from './api_endpoints/list_distribution';
export {default as ListDistribution} from './api_endpoints/list_distribution';
export const listDistribution = new ListDistribution(session);

import ListChildren from './api_endpoints/list_children';
export {default as ListChildren} from './api_endpoints/list_children';
export const listChildren = new ListChildren(session);

import UpdateChild from './api_endpoints/update_child';
export {default as UpdateChild} from './api_endpoints/update_child';
export const updateChild = new UpdateChild(session);

import DestroyChild from './api_endpoints/destroy_child';
export {default as DestroyChild} from './api_endpoints/destroy_child';
export const destroyChild = new DestroyChild(session);

import CreateProtocolSubscription from './api_endpoints/create_protocol_subscription';
export {default as CreateProtocolSubscription} from './api_endpoints/create_protocol_subscription';
export const createProtocolSubscription = new CreateProtocolSubscription(session);

import DestroyProtocolSubscription from './api_endpoints/destroy_protocol_subscription';
export {default as DestroyProtocolSubscription} from './api_endpoints/destroy_protocol_subscription';
export const destroyProtocolSubscription = new DestroyProtocolSubscription(session);

import ListMyProtocolSubscriptions from './api_endpoints/list_my_protocol_subscriptions';
export {default as ListMyProtocolSubscriptions} from './api_endpoints/list_my_protocol_subscriptions';
export const listMyProtocolSubscriptions = new ListMyProtocolSubscriptions(session);

import Statistics from './api_endpoints/statistics';
export {default as Statistics} from './api_endpoints/statistics';
export const statistics = new Statistics(session);

export function test() {
  console.log('hoi!');
}
